<template>
    <!--弹窗-->
    <el-dialog width="70%" title="负责人列表" :visible.sync="visible" :before-close="handleClose">
        <el-form ref="form" :inline="true" class="query-form" size="mini">
            <el-form-item label="国家: " prop="state">
                <el-select
                    v-model="query.state"
                    ref="carrerSelect"
                    style="width: 150px;"
                    size="mini"
                    filterable
                >
                    <el-option
                        v-for="item in $common.us_arr"
                        :key="item.us"
                        :label="item.title"
                        :value="item.us"
                        :disabled="item.disabled">
                        <div class="keywords_arr_div">
                            <icon-svg :icon-class="item.us.toUpperCase()"
                                      style="font-size: 24px;margin-right:5px;"></icon-svg>
                            <span style="font-weight: 700; font-size: 14px;margin-left: 10px;">{{ item.title }}</span>
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="ASIN：" class="query-form-item">
                <el-input style="width: 150px;" clearable v-model="query.asin" placeholder="请输入ASIN"
                          size="mini"></el-input>
            </el-form-item>

            <el-form-item label="负责人：" class="query-form-item">
                <el-input style="width: 150px;" clearable v-model="query.supervisor" placeholder="请输入负责人"
                          size="mini"></el-input>
            </el-form-item>

            <el-button type="primary" @click="onSubmit" size="mini">查询</el-button>
            <el-button type="success" @click.native="uploadFunc()" size="mini">上传</el-button>

        </el-form>
        <el-table
            :row-key="getRowKeys"
            v-loading="loading"
            :data="list"
            class="table_content"
            size="mini"
            border
            height="400"
            style="width: 100%; margin-top: 10px">
            <el-table-column
                label="id"
                :resizable="false"
                prop="id"
                align="center">
            </el-table-column>
            <el-table-column
                label="Asin"
                :resizable="false"
                prop="asin"
                align="center">
            </el-table-column>
            <el-table-column
                min-width="140"
                label="国家"
                :resizable="true"
                prop="state"
                align="center">
            </el-table-column>
            <el-table-column
                min-width="140"
                label="负责人"
                :resizable="true"
                prop="supervisor"
                align="center">
            </el-table-column>
        </el-table>

        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="query.limit"
                       :page-sizes="[10, 20, 50]" :total="query.total" background :current-page="query.page"
                       style="margin-top: 10px;display: flex;justify-content: end;"
                       layout="total, sizes, prev, pager, next">
        </el-pagination>

        <el-row style="margin-top:17px; ">
            <el-button style="float:right;margin-left:6px;" size="mini" type="danger" plain @click="handleClose()">关 闭
            </el-button>
        </el-row>

        <personInChargeUpload :visible="addSubLibraryModal" @close-callback="closeCllback"
                              title="上传产品负责人"/>

    </el-dialog>
</template>
<script>
    import * as api from '@/api/advAnalys/advAnalys.js'
    import personInChargeUpload from './personInChargeUpload'

    export default {
        data() {
            return {
                addSubLibraryModal: false,
                visible: false,
                list: [],
                selectIds: [],
                loading: false,
                selection_id: '',
                query: {
                    supervisor: '',
                    state: '',
                    asin: '',
                    page: 1,
                    limit: 10,
                    total: 0,
                },
                rules: {
                    name: [{required: true, message: '请输入名称', trigger: 'blur'},]
                },
            }
        },
        components: {personInChargeUpload},
        methods: {
            closeCllback(isShow) {
                this.addSubLibraryModal = false
                isShow == true && this.getList()
            },
            uploadFunc() {
                this.addSubLibraryModal = true
            },
            onSubmit() {
                this.query.page = 1
                this.getList()
            },
            showModal(ids) {
                this.visible = true
                this.selectIds = ids
                this.getList()
            },
            getRowKeys(row) {
                return row.id
            },
            jumpUrl(url) {
                window.open(url, '_blank')
            },
            chooseItem(data) {
                this.$emit('choose1688Info', data)
            },
            //分页
            handleCurrentChange(val) {
                this.query.page = val
                this.getList()
            },
            handleSizeChange(val) {
                this.query.limit = val
                this.getList()
            },
            getList() {
                this.loading = true
                api.logistics_asin_supervisor_index(this.query).then(res => {
                    if (res.code === 0) {
                        const responseList = res.data.list || []
                        this.list = responseList
                        this.query.total = res.data.total || 0
                    } else {
                        this.$message({type: 'error', message: res.message})
                    }
                }).catch(() => {
                    this.loading = false
                }).finally(() => {
                    this.loading = false
                })
            },
            // 关闭弹窗
            handleClose(flag) {
                this.visible = false
                this.list = []
                this.initQueryParam()
                this.$emit('refreshPage', flag)
            },
            initQueryParam() {
                this.query = {
                    supervisor: '',
                    state: '',
                    asin: '',
                    page: 1,
                    limit: 10,
                    total: 0,
                }
            }
        }
    }
</script>
<style type="text/scss" lang="scss" scoped>
    .content {
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #cecfd1;
        font-size: 12px;
        color: #000;

        .shu {
            border-right: 1px solid #cecfd1;
        }

        .content-div {
            width: 50%;
            padding: 25px 20px;
        }

        .content-buttom {
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #cecfd1;
            padding-bottom: 8px;
            margin-bottom: 10px;
        }

        .content-buttom-txet {
            color: rgb(57, 187, 252);
            cursor: pointer;
        }

        .content-data {
            width: 100%;
            height: 230px;
            overflow: auto;

            .content-list {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin: 10px 0;

                .cha {
                    cursor: pointer;
                    font-size: 15px;
                    color: rgb(158, 192, 209);
                    margin: 0 10px 0 12px;
                }
            }
        }

        /deep/ .content-data::-webkit-scrollbar {
            width: 3px;
            height: 5px;
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }

        /deep/ .content-data::-webkit-scrollbar-track-piece {
            background-color: #ffff;
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }

        /deep/ .content-data::-webkit-scrollbar-thumb:vertical {
            height: 5px;
            background-color: rgba(144, 147, 153, 0.5);
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }

        /deep/ .content-data::-webkit-scrollbar-thumb:horizontal {
            width: 3px;
            background-color: rgba(144, 147, 153, 0.5);
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }
    }

    .media-txt {
        font-size: 15px;
        color: #6a6c6f;
        font-weight: 600;
        margin-bottom: 8px;
    }

    /deep/ .el-dialog__body {
        padding: 0px 20px 20px 20px !important;
    }

    /deep/ .el-form-item {
        margin-bottom: 12px !important;
    }
</style>
